










































import {Component, Vue} from "vue-property-decorator";

@Component({
	components: {},
	mounted() {
		this.$store.dispatch("country/list");
		this.$store.dispatch("language/list");
		this.$store.dispatch("currency/list");
	}
})
export default class App extends Vue {
	public drawer: boolean = false;
}
